import "./lazyLoad";
import "./categoryToggle";
import "./filterToggle";
import setupProductFavorites from "./setupProductFavorites";
import setupProductAddToCart from "./setupProductAddToCart";
import { setupNotifyStockFeature } from "../singleProduct/singleProduct"; // Import notify feature
import "./scrollToTop";

// --- NEW: Universal Initializer Function ---
export function initializeProductCards() {
  setupProductFavorites();
  setupProductAddToCart();
  setupNotifyStockFeature();
}
// --- END: NEW ---

document.addEventListener("DOMContentLoaded", () => {
  initializeProductCards(); // Call it once on initial page load
});

// Listen for lazy-loaded products on archive page
document.addEventListener("productsLazyLoaded", () => {
  initializeProductCards();
});
